import React, { useState } from "react";
import { Button } from "reusable";
import { GetInTouchModal } from ".";
import "reusable/styles/get-in-touch.css";

interface GetInTouchProps {
  profileOwnerId: string;
  visitorId: string;
  isPremium: boolean;
  profilePicture?: string;
  ownerName?: string;
}

const GetInTouch: React.FC<GetInTouchProps> = ({ profileOwnerId, visitorId, isPremium, profilePicture, ownerName }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button className="get-in-touch-btn" onClick={() => setOpen(true)}>
        Get in Touch
      </Button>      <GetInTouchModal
        isOpen={open}
        onClose={() => setOpen(false)}
        profileOwnerId={profileOwnerId}
        visitorId={visitorId}
        isPremium={isPremium}
        profilePicture={profilePicture}
        ownerName={ownerName}
      />
    </>
  );
};

export default GetInTouch;
